module.exports = __webpack_public_path__ + "static/img/7.40d34bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/7.png
// module id = GS18
// module chunks = 0